// extracted by mini-css-extract-plugin
export default {"trapezoid":"seats_trapezoid__u2KYo","screen":"seats_screen__OstJs"};